<template>
  <div class="menu-wrapper" id="editorMenu" :class="stage" @click="hiddenAllTipsFun()">

    <!-- 一页纸 -->
    <div class="menu-item one-page" :class="{'active': autoOnePage}" :style="{width: this[`${stage}StageWidthMap`].onePage}" @click="autoOne()">
      <template v-if="stage === 'one'">
        <i class="iconfont iconyiyezhi"></i>
      </template>
      <template v-else-if="stage === 'second'">
        {{!autoOnePage ? '智能一页' : '取消一页'}}
      </template>


      <!-- <div class="tips-wrapper"></div> -->
      <div class="tips-wrapper" :class="{'one-page': stage === 'one'}">自动一页</div>
    </div>

    <!-- 排序 -->
    <div class="menu-item module-sort" :style="{width: this[`${stage}StageWidthMap`].moduleSort}" @click="cvAutoSort(true)">
      <i class="iconfont iconpaixu"></i>

      <div class="tips-wrapper">智能排序</div>
    </div>

    <!-- 字体 -->
    <div class="menu-item font" :style="{width: this[`${stage}StageWidthMap`].font}">

      <div class="tips-hover mySelect cursor_p pr">
        <div class="model f_13 ellipsis pr" v-if="cvDetail.format_info.font" @click.stop="showTipsBoxFun('');updateFontState(!showFontState)">{{ cvDetail.format_info.font | fontFamily(self) }}</div>
        <div class="model f_13 placeholder pr" v-else  @click.stop="showTipsBoxFun('');updateFontState(!showFontState)" >请选择</div>
        <i class="iconfont iconxiala" :class="[showFontState?'active':'']" @click.stop="showTipsBoxFun('');updateFontState(!showFontState)"></i>

        <div class="tips-wrapper">字体</div>
      </div>

      <div class="fontList pa bg_fff" :class="cvDetail.basic_info.lang==='cn'?'widthAuto':''" v-if="showFontState">
        <div class="popper__arrow pa"></div>
        <template v-for="item in userFontFamily[cvDetail.basic_info.lang]">
          <div class="font f_14 color_60" :class="[item.id === font?'color_red':'']" :key="item.id" v-if="item.hasFont" @click.stop="toggleFont(cvDetail.basic_info.lang,item)">
<!--            <span>{{ item.id }} - {{ font }}</span>-->
            <span :class="['iconfont',item.iconfont]"></span>
            <img src="https://files.wondercv.com/pc-cvs/vip-icon.png" class="is-vip-icon" v-if="item.isVip" />
          </div>
          <el-tooltip v-else :key="item.id" class="item" effect="dark" placement="right">
            <div slot="content">系统中暂无此字体<br/>字体效果下载简历生效</div>
            <div class="font f_14 color_60" :class="[item.id === font? 'color_red' : '']" @click.stop="toggleFont(cvDetail.basic_info.lang,item)">
              <span :class="['iconfont',item.iconfont]"></span>
              <img src="https://files.wondercv.com/pc-cvs/vip-icon.png" class="is-vip-icon" v-if="item.isVip" />
            </div>
          </el-tooltip>
        </template>
      </div>

    </div>

    <!-- 字号 -->
    <div class="menu-item size" :style="{width: this[`${stage}StageWidthMap`].size}">
      <el-select v-model="cvDetail.format_info.font_size" placeholder="请选择" @change="changeFontSize" @focus="hiddenAllTipsFun()">
        <el-option
            v-for="item in FONT_SIZE"
            :class="{'color_red': item.slice(0, 2) === cvDetail.format_info.font_size}"
            :key="item"
            :value="item"
            :label="item">
        </el-option>
      </el-select>

      <div class="tips-wrapper">字号</div>
    </div>

    <!-- 行距 -->
    <div class="menu-item line-spacing" :style="{width: this[`${stage}StageWidthMap`].lineSpacing}">
      <i class="menu-icon iconfont iconhangju" @click="toggleSelectFun('lineSpacingDom')"></i>
      <el-select v-model="cvDetail.format_info.line_spacing" ref="lineSpacingDom" placeholder="请选择" @change="setFormatInfo({line_spacing: cvDetail.format_info.line_spacing})" @focus="hiddenAllTipsFun()">
        <el-option
            v-for="item in LINE_HEIGHT"
            :key="item"
            :value="item"
            :label="item">
        </el-option>
      </el-select>

      <div class="tips-wrapper">行距</div>
    </div>

    <!-- 页边距 -->
    <div class="menu-item page-margin" :style="{width: this[`${stage}StageWidthMap`].pageMargin}">
      <i class="menu-icon iconfont iconyebianju" @click="toggleSelectFun('pageMarginDom')"></i>
      <el-select v-model="cvDetail.format_info.page_margin" ref="pageMarginDom" placeholder="请选择" @change="setFormatInfo({ page_margin: cvDetail.format_info.page_margin })" @focus="hiddenAllTipsFun()">
        <el-option
          v-for="item in PAGE_PADDING"
          :key="item"
          :value="item"
          :label="item">
        </el-option>
      </el-select>

      <div class="tips-wrapper">页边距</div>
    </div>

    <!-- 主题色 -->
    <div class="menu-item theme-color" :style="{width: this[`${stage}StageWidthMap`].themeColor}">

      <div class="tips-hover title-color-box" @click.stop="showTipsBoxFun('titleColor')">
        <div class="title-color-result">
          <div :style="{'background': cvDetail.format_info.title_color}">
            <img class="pattern-img" src="https://logo.wondercv.com/banners/lDioR3FQgDjz06G.png" alt="">
            <img class="new-icon" src="https://logo.wondercv.com/banners/41Gix4WPjxhRQKi.gif" alt="">
          </div>
          <!-- <span v-if="stage === 'second'">主题色</span> -->
        </div>
        <i class="iconfont iconxiala"></i>
        <div class="tips-wrapper">主题色</div>
      </div>

      <div class="title-color-tips" v-if="showTipsBoxType === 'titleColor'">
        <div class="popper__arrow pa"></div>

        <div class="theme-title">主题颜色</div>

        <div class="theme-color-content">
          <div :class="['theme', `theme-${index}`, (cvDetail.format_info.title_color === item) && !cvDetail.format_info.title_select_color ? 'action' : '']"
                v-for="(item, index) in THEME"
                :key="item"
                :style="{background: item}"
                @click="setFormatInfo({title_select_color: false, title_color: item})">
            <i class="iconfont iconcheck"></i>
          </div>

          <div v-show="cvDetail.format_info.title_format !== 'icon'" :class="['theme', 'theme-select', cvDetail.format_info.title_select_color ? 'action' : '']" @click.stop>
            <i class="iconfont iconcheck"></i>
            <input type="color" v-model="cvDetail.format_info.title_color" @input="debounce(() => setFormatInfo({title_select_color: true, title_color: cvDetail.format_info.title_color}), 300)">
          </div>

          <div class="theme-vip-bg"></div>
          <img class="vip-icon" src="https://logo.wondercv.com/banners/mlgVQD052Tu9ef2.png" alt="" />
        </div>

        <div class="theme-title background-theme-title">背景样式</div>

        <div class="pattern-select-content">
          <div
            v-for="(item, index) in PATTERN_DATA"
            :key="index"
            class="pattern-item"
            :class="{'active': cvDetail.format_info.pattern_type === item.name}"
            @click="debounce(() => setFormatInfo({
              pattern_type: item.name,
              pattern: item.pattern
            }), 300)"
          >
            <i v-if="cvDetail.format_info.pattern_type === item.name" class="iconfont iconxuanzhong"></i>
            <img v-if="item.member" class="vip-icon" src="https://logo.wondercv.com/banners/mlgVQD052Tu9ef2.png" alt="">
            <img v-if="item.thumbnail" class="thumbnail-image" :src="item.thumbnail" width="66" height="66" alt="">
          </div>
        </div>

        <div class="theme-title">背景位置</div>

        <div class="pattern-position-content">
          <div 
            class="position-item"
            :class="{'active': cvDetail.format_info.pattern_position === 'right'}"
            @click="debounce(() => setFormatInfo({ pattern_position: 'right' }))"
          >
            居右
          </div>
          <div
            class="position-item"
            :class="{'active': cvDetail.format_info.pattern_position === 'left'}"
            @click="debounce(() => setFormatInfo({ pattern_position: 'left' }))"
          >
            居左
          </div>
        </div>
      </div>

    </div>

    <!-- 文本格式 -->
    <div class="menu-item text-format" :style="{width: this[`${stage}StageWidthMap`].textFormat}">

      <div class="tips-hover module-box" @click.stop="showTipsBoxFun('textFormat')">
        <div class="module-result">
          <i class="iconfont iconwenbengeshi"></i>
        </div>
        <i class="iconfont iconxiala"></i>
        <div class="tips-wrapper">文本格式</div>
      </div>

        <div class="module-tips" v-if="showTipsBoxType === 'textFormat'" @click.stop>
          <div class="popper__arrow pa"></div>

          <h6 class="module-tips-header">文本格式</h6>
          <div class="module-tips-content">

            <!-- 日期时间 -->
            <div class="text-format-item">
              <h6 class="text-format-item-title">日期时间</h6>
              <div class="text-format-item-list">
                <button :class="[cvDetail.format_info.time_format === 'default' ? 'action' : '']"
                    @click="setFormatInfo({time_format: 'default'})">
                  <span>2021年1月</span>
                </button>
                <button :class="[cvDetail.format_info.time_format === 'number' ? 'action' : '']"
                        @click="setFormatInfo({time_format: 'number'})">
                  <span>2021.01</span>
                </button>
              </div>
            </div>

            <!-- 经历标题 -->
            <div class="text-format-item">
              <h6 class="text-format-item-title">经历标题</h6>
              <div class="text-format-item-list">
                <button :class="[cvDetail.format_info.body_format === 'two_line' ? 'action' : '']"
                    @click="setFormatInfo({body_format: 'two_line'})">
                  <span>双行标题</span>
                </button>
                <button :class="[cvDetail.format_info.body_format === 'one_line' ? 'action' : '', {'disabled': hasWorkSubItem }]"
                        @click="hasWorkSubItem ? null : setFormatInfo({body_format: 'one_line'})">
                  <span>单行标题</span>
                </button>
              </div>
            </div>
            <div class="text-format-item-radio" v-if="cvDetail.format_info.body_format === 'two_line'">
              <cv-radio v-model="cvDetail.format_info.format_priority" :list="priorityList" :disabled="cvDetail.format_info.body_format === 'one_line'"
                        @change="body_format === 'one_line' ? null :setFormatInfo({format_priority: cvDetail.format_info.format_priority})"/>
            </div>
            <div class="text-format-item-radio" v-if="cvDetail.format_info.body_format === 'one_line'">
              <cv-radio v-model="cvDetail.format_info.punctuation_format" :disabled="cvDetail.format_info.body_format === 'two_line'"
                        :list="punctuation_format_list"
                        @change="body_format === 'two_line' ? null :setFormatInfo({punctuation_format: cvDetail.format_info.punctuation_format})"/>
            </div>
            <!-- <div class="text-format-item-radio-desc">
               同一公司添加多段职位信息时仅支持【双行标题-地点优先】样式
            </div> -->

            <!-- 简历认证 -->
            <div class="text-format-item">
              <h6 class="text-format-item-title">简历认证</h6>
              <div class="text-format-item-list special">
                <button :class="[ (cvDetail.format_info.watermark === '') ? 'action' : '']" @click="selectResumeCertification({watermark :''})">
                  <i class="buttonicon iconfont iconbuxianshi"></i>
                  <span>不显示</span>
                </button>
                <button :class="[ cvDetail.format_info.watermark === 'basic' ? 'action' : '']" @click="selectResumeCertification({watermark :'basic'})">
                  <i class="buttonicon iconfont iconchaojijianli"></i>
                  <span>超级简历</span>
                </button>
                <button :class="[ cvDetail.format_info.watermark === 'better' ? 'action' : '', score < 80 ? 'disabled' : '']" :disabled="score < 80" @click="selectResumeCertification({watermark :'better'})">
                  <i class="buttonicon iconfont iconyouxiujianli"></i>
                  <span>优秀简历</span>
                  <div class="hover-tooltip hover-tooltip-80">
                    简历分数达到80分可使用此标识，请先完善简历
                  </div>
                </button>
                <button :class="[ cvDetail.format_info.watermark === 'best' ? 'action' : '', score < 95 ? 'disabled' : '']" :disabled="score < 95" @click="selectResumeCertification({watermark :'best'})">
                  <i class="buttonicon iconfont icondingjianjianli"></i>
                  <span>顶尖简历</span>
                  <div class="hover-tooltip hover-tooltip-95">
                    简历分数达到95分可使用此标识，请先完善简历
                  </div>
                </button>
              </div>
            </div>

          </div>

        </div>

    </div>

    <!-- 模板样式 -->
    <div class="menu-item more-sort" :style="{width: this[`${stage}StageWidthMap`].moreSort}">

      <div class="tips-hover module-box" @click.stop="showTipsBoxFun('moreSort')">
        <div class="module-result">
          <i v-if="stage === 'one'" class="iconfont iconpaiban2"></i>
          <span v-else-if="stage === 'second'">模板样式</span>
        </div>
        <i class="iconfont iconxiala"></i>
        <div class="tips-wrapper">模板样式</div>
      </div>

      <div class="module-tips" v-if="showTipsBoxType === 'moreSort'" @click.stop>
        <div class="popper__arrow pa"></div>

        <h6 class="module-tips-header">HR 推荐模板样式<img class="vip" src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt=""></h6>
        <div class="module-tips-content">
          <div class="template-style-list">

            <img class="template-style-item"
                 :class="{'active': cvDetail.format_info.template_type === item.imgSrc}"
                 v-for="(item ,index) in tempStyleList"
                 :key="index"
                 :src="item.imgSrc"
                 alt=""
                 @click="useTemplateStyleFun(item, index)">

          </div>
        </div>


        <h6 class="module-tips-header">自定义模板样式</h6>
        <div class="module-tips-content">

          <!-- 基本信息 -->
          <div class="more-sort-item">
            <h6 class="more-sort-item-title">基本信息：</h6>
            <div class="more-sort-item-list">
              <button :class="[profile.show_attr_name === 1 ? 'action' : '']"
                      @click="setFormatInfo({template_type: null});selectInfo(1)">
                <i class="buttonicon iconfont iconwenzi"></i>
                <span>文字</span>
              </button>
              <button :class="[profile.show_attr_name === 2 ? 'action' : '']"
                      @click="setFormatInfo({template_type: null});selectInfo(2)">
                <i class="buttonicon iconfont icontubiao"></i>
                <span>图标</span>
              </button>
              <button :class="[profile.show_attr_name === 0 ? 'action' : '']"
                      @click="setFormatInfo({template_type: null});selectInfo(0)">
                <i class="buttonicon iconfont iconjianjie"></i>
                <span>简洁</span>
              </button>
            </div>
          </div>

          <!-- 布局 -->
          <div class="more-sort-item">
            <h6 class="more-sort-item-title">头部布局：</h6>
            <div class="more-sort-item-list">
              <button :class="[cvDetail.format_info.head_format === 'left' ? 'action' : '']"
                      @click="setFormatInfo({head_format:'left', template_type: null})">
                <i class="buttonicon iconfont iconjuzuo"></i>
                <span>居左</span>
              </button>
              <button :class="[cvDetail.format_info.head_format === 'center' ? 'action' : '']"
                      @click="setFormatInfo({head_format:'center', template_type: null})">
                <i class="buttonicon iconfont iconjuzhong"></i>
                <span>居中</span>
              </button>
              <button :class="[cvDetail.format_info.head_format === 'body_center' ? 'action' : '']"
                      @click="setFormatInfo({head_format:'body_center', template_type: null})">
                <i class="buttonicon iconfont icondatouxiang"></i>
                <span>商务</span>
                <img class="vip-icon" src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt="">
              </button>
            </div>
          </div>

          <!-- 顶部 -->
          <div class="more-sort-item">
            <h6 class="more-sort-item-title">纸张样式：</h6>
            <div class="more-sort-item-list">
              <button :class="[cvDetail.format_info.top_format === 'default' ? 'action' : '']"
                      @click="setCvHeaderLineShow('default', false, false)">
                <i class="buttonicon iconfont iconmoren"></i>
                <span>默认</span>
              </button>
              <button :class="[cvDetail.format_info.top_format === 'line' ? 'action' : '']"
                      @click.stop="setCvHeaderLineShow('line', true, false)">
                <i class="buttonicon iconfont iconxinzhi"></i>
                <span>正式</span>
                <img class="vip-icon" src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt="">
              </button>
            </div>
          </div>

          <div class="top-line-color-select" v-show="isShowCvHeaderLine || cvDetail.format_info.top_format === 'line'">
            <div :class="['theme-header-line', 'theme', `theme-${index}`, (cvDetail.format_info.top_line_color === item) && !cvDetail.format_info.top_line_select_color ? 'action' : '']"
                  v-for="(item, index) in HEADER_LINE_THEME"
                  :key="item"
                  :style="{background: item}"
                  @click="setFormatInfo({top_line_select_color: false, top_line_color: item})">
              <i class="iconfont iconcheck"></i>
            </div>
            <div :class="['theme', 'theme-select', cvDetail.format_info.top_line_select_color ? 'action' : '']" @click.stop>
              <i class="iconfont iconcheck"></i>
              <input type="color" v-model="cvDetail.format_info.top_line_color" @input="debounce(() => setFormatInfo({top_line_select_color: true, top_line_color: cvDetail.format_info.top_line_color}), 300)">
            </div>
          </div>

            <!-- 标题样式 -->
          <div class="more-sort-item title-format">
            <h6 class="more-sort-item-title">标题样式：</h6>
            <div class="more-sort-item-list">
              <button :class="[cvDetail.format_info.title_format === 'default' ? 'action' : '']"
                @click="changeTileFormat('default', false)">
                <i class="buttonicon iconfont iconzhuanye"></i>
                <span>通用</span>
              </button>
              <button :class="[cvDetail.format_info.title_format === 'strip' ? 'action' : '']"
                      @click="changeTileFormat('strip', false)">
                <i class="buttonicon iconfont iconqingxin"></i>
                <span>专业</span>
                <img class="vip-icon" src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt="">
              </button>
              <button :class="[cvDetail.format_info.title_format === 'tag' ? 'action' : '']"
                      @click="changeTileFormat('tag', false)">
                <i class="buttonicon iconfont icontuchu"></i>
                <span>突出</span>
                <img class="vip-icon" src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt="">
              </button>
              <button :class="[cvDetail.format_info.title_format === 'icon' ? 'action' : '']"
                      @click="changeTileFormat('icon', false)">
                <i class="buttonicon iconfont icontubiao1"></i>
                <span>简约</span>
                <img class="vip-icon" src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt="">
              </button>
            </div>
          </div>

          <!-- 主题色选择 -->
          <div class="more-sort-item title-format">
            <h6 class="more-sort-item-title">标题颜色：</h6>
            <div class="more-sort-item-list bg-color">
              <div :class="['theme', `theme-${index}`, (cvDetail.format_info.title_color === item) && !cvDetail.format_info.title_select_color ? 'action' : '']"
                   v-for="(item, index) in THEME"
                   :key="item"
                   :style="{background: item}"
                   @click="setFormatInfo({title_select_color: false, title_color: item})">
                <i class="iconfont iconcheck"></i>
              </div>

              <div v-show="cvDetail.format_info.title_format !== 'icon'" :class="['theme', 'theme-select', cvDetail.format_info.title_select_color ? 'action' : '']" @click.stop>
                <i class="iconfont iconcheck"></i>
                <input type="color" v-model="cvDetail.format_info.title_color" @input="debounce(() => setFormatInfo({title_select_color: true, title_color: cvDetail.format_info.title_color}), 300)">
              </div>
              <div class="theme-vip-bg"></div>
              <img class="vip-icon" src="https://files.wondercv.com/pc-cvs/vip-icon.png" alt="" />
            </div>
          </div>

        </div>

      </div>

    </div>

    <!-- 添加模块 -->
    <div class="menu-item add-module" :class="{'no-more': moduleList.length < 6}" :style="{width: this[`${stage}StageWidthMap`].addModule}">

      <div class="tips-hover module-box" @click.stop="showTipsBoxFun('addModule')">
        <div class="module-result">
          <i v-if="stage === 'one'" class="iconfont icontianjia2"></i>
          <span v-else-if="stage === 'second'">添加模块</span>
        </div>
        <i class="iconfont iconxiala"></i>
        <div class="tips-wrapper add-module">添加模块</div>
      </div>

      <div class="module-tips" v-if="showTipsBoxType === 'addModule'" @click.stop>
        <div class="popper__arrow pa"></div>

          <h6 class="module-tips-header">添加模块</h6>
        <div class="module-tips-content">

          <div class="add-module-list">
            <template v-for="(item, index) in moduleList">
              <div class="module" :key="index" @click="addModule(item)" v-if="!((item.type==='school' || item.type==='custom' || item.type==='opus') && isMentorEditor) " >
                <div class="info">
                  <i :class="['iconfont', item.iconfont]"></i>
                  <div class="text">
                    <div class="name">
                      {{item.name}}
                      <img class="vip-icon" src="https://files.wondercv.com/pc-cvs/vip-icon.png" v-if="item.hasVip" />
                    </div>
                    <div class="msg text-overflow">{{item.placeholder}}</div>
                  </div>
                </div>
              </div>
            </template>
          </div>

        </div>

      </div>

    </div>

  </div>
</template>

<script>
import api from '@/api'
import { mapState, mapMutations, mapActions } from 'vuex'
import { THEME, HEADER_LINE_THEME, FONT_SIZE, LINE_HEIGHT, PAGE_PADDING, PATTERN_DATA } from '@/assets/js/const'
import { dealResumeDomScroll } from '@/assets/js/util'
import cvRadio from '@/components/base/cvRadio'
import recommendTemplateStyle from '@/assets/json/recommend-template-style.json'
import { dealCvDataMixin, cvMixin } from '@/assets/js/mixins'

const getNum = data => {
  return data.replace(/(\d*)?\w.*/gim, '$1')
}

// 570 686 720
// 570 - 686 :每个固定百分百长度，随父元素长度变化
// 686 - 720 :固定长度，个别item 样式有变化
export default {
  props: {
    // 阶段类型
    // one：一阶段（570 - 686）
    // second：二阶段（686 - 720）
    stage: {
      type: String,
      default: 'one'
    }
  },
  mixins: [dealCvDataMixin, cvMixin],
  data () {
    return {
      self:this,
      THEME,
      HEADER_LINE_THEME,
      FONT_SIZE,
      LINE_HEIGHT,
      PAGE_PADDING,
      PATTERN_DATA,
      autoOnePageState: false, //是否正在进行一页纸
      fontSize: '12pt',
      lineHeight: 12,
      font: '',
      padding: '',
      info: 1,
      format_pref_show_attr_name: 1,
      time_format: 'default', // 日期格式 number
      format_priority: 'time', // 时间优先
      body_format: 'two_line', // 两行标题
      punctuation_format: 'show_punctuation', // 显示分隔符
      titleColorTipsVisible: false,
      moreSortTipsVisible: false,
      addModuleTipsVisible: false,
      isShowCvHeaderLine: false,
      textFormatTipsVisible: false,
      showTipsBoxType: '', // titleColor  moreSort addModule textFormat
      listMenu: [], // 现有的模块
      // 570 - 686 一阶段 各模块宽度（百分百）
      oneStageWidthMap: {
        onePage: '5.26%',
        moduleSort: '5.26%',
        font: '14.03%',
        size: '9.82%',
        lineSpacing: '8.07%',
        pageMargin: '8.07%',
        themeColor: '8.43%',
        textFormat: '8.07%',
        moreSort: '8.07%',
        addModule: '8.07%'
      },
      // 686 - 720 二阶段 各模块宽度（px）
      secondStageWidthMap: {
        onePage: '64px',
        moduleSort: '30px',
        font: '80px',
        size: '56px',
        lineSpacing: '46px',
        pageMargin: '46px',
        themeColor: '48px',
        textFormat: '46px',
        moreSort: '82px',
        addModule: '82px'
      },
      // 时间地址优先
      priorityList: [
        {
          value: 'time',
          content: '<div style="color: #606060;">时间优先</div>'
        },
        {
          value: 'city',
          content: '<div style="color: #606060;">地点优先</div>'
        }
      ],
      // 分隔符
      punctuation_format_list: [
        {
          value: 'show_punctuation',
          content: '<div style="color: #606060;">使用分隔符号</div>'
        },
        {
          value: 'not_show_punctuation',
          content: '<div style="color: #606060;">不使用分隔符号</div>'
        }
      ],
      tempStyleList: recommendTemplateStyle.editor
    }
  },
  components: {
    cvRadio
  },
  created () {
    let { font, line_spacing, font_size, page_margin, time_format, format_priority, body_format, punctuation_format, } = this.cvDetail.format_info
    this.font = font
    this.fontSize = font_size ? `${ font_size }pt` : ''

    this.lineHeight = line_spacing
    this.padding = page_margin
    this.time_format = time_format
    this.format_priority = format_priority
    this.body_format = body_format
    this.punctuation_format = punctuation_format

    this.format_pref_show_attr_name = this.profile.show_attr_name

    this.listMenu = JSON.parse(JSON.stringify(this.menuList))

    // 获取已经未选中的模块
    // this.getFilterModule()

    document.addEventListener('click', () => {
      this.hiddenAllTipsFun()
    })
  },
  mounted() {
    let dom = document.querySelectorAll('.menu-wrapper .el-input__suffix-inner')
    for (let i = 0; i < dom.length; i++) {
      let d = document.createElement('i')
      d.classList.add('iconfont', 'iconxiala')
      dom[i].appendChild(d)
    }
  },
  watch:{
    menuList (val) {
      this.listMenu = JSON.parse(JSON.stringify(this.menuList))
    },
    score (value, old) {
      if(value > old) return;
      if(this.cvDetail.format_info.watermark){
        this.selectResumeCertification({watermark : value < 80 ?  'basic'  : (value > 95 ? 'best' : 'better') })
      }
    },
    editorMenuTipsType (newValue) {
      this.showTipsBoxType = newValue
      console.log('chen=====>', newValue,  this.showTipsBoxType)
    }
  },
  filters:{
    fontFamily:function(value, self){
      let { lang } = self.cvDetail.basic_info;
      return self.userFontFamily[lang].filter(item=>item.id===value)[0].cnName
    }
  },
  computed: {
    ...mapState('cvs', [ 'cvs', 'cv', 'downloadCv' ]),
    ...mapState('editor', [ 'cvToken', 'cvDetail', 'currentInfo', 'works', 'orgs', 'edus', 'backUpFormatInfo', 'profile', 'backUpProfile', 'autoOnePage', 'onePageFunction', 'score', 'hasWorkSubItem', 'editorMenuTipsType' ]),
    ...mapState('experience', [ 'showFontState','userFontFamily', 'experienceList' ]),
    ...mapState('manage', ['menuList', 'editModuleData', 'moduleList', 'reloadMenuList']),


    isMentorEditor () {
      return window.location.href.includes('mentor')
    }
  },
  methods: {
    ...mapActions('editor', [ 'cvAutoSort', 'updateCvDetail', 'createCvDetail' ]),
    ...mapActions('manage',['getMenuList', 'getFilterModule']),
    ...mapMutations('editor', [ 'setCvDetail', 'setBackUpFormatInfo', 'setProfileData', 'setBackUpProfile', 'setAutoOnePage','setOldLineHeight', 'updateWorkHasSubItem', 'setEditorMenuTipsType' ]),
    ...mapMutations('experience', [ 'updateSidebarOption', 'updateFontState', 'updateExperienceList' ]),
    ...mapMutations('manage',['setReloadMenuList', 'setMenuList', 'setFilterModule']),

    useTemplateStyleFun (item, index) {
      // 基本信息
      this.selectInfo(item.show_attr_name)
      // 布局
      this.setFormatInfo({head_format: item.head_format})
      // 顶部
      this.setCvHeaderLineShow(item.top_format, item.top_format === 'line', true)
      // 标题样式
      this.changeTileFormat(item.title_format, true)
      // 主题色
      this.setFormatInfo({title_select_color: false, title_color: item.title_color})
      // 模版类型
      this.setFormatInfo({template_type: item.imgSrc})
    },
    debounce (fn, timeInterval) {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      let arg = [ ...arguments ].filter((item, index) => {
        return index > 1
      })
      this.timer = setTimeout(() => {
        fn.apply(this, arg)
      }, timeInterval)
    },
    hiddenAllTipsFun () {
      this.showTipsBoxFun('')
      this.updateFontState(false)
    },
    showTipsBoxFun (type) {
      this.updateFontState(false)
      if (type === this.showTipsBoxType) {
        this.showTipsBoxType = ''
        this.setEditorMenuTipsType(null)
      } else {
        this.showTipsBoxType = type
        this.setEditorMenuTipsType(type)
      }
    },
    // 切换简历 标题样式（类型）
    changeTileFormat (type, isTemplateStyle) {
      if (isTemplateStyle) {
        this.setFormatInfo({title_format: type})
      } else {
        this.setFormatInfo({title_format: type, template_type: null})
      }
      // 如果选择了图标标题，并且这个时候标题颜色选择的自定义颜色，因为图标标题没有自定义颜色选项，所以需要把标题颜色重置为默认值
      if (type === 'icon' && this.cvDetail.format_info.title_select_color) {
        this.setFormatInfo({title_select_color: false, title_color: '#000000'})
      }
    },
    toggleSelectFun (type) {
      // console.log(this.$refs[type])
      this.$refs[type].toggleMenu()
    },
    // 一页纸
    autoOne () {
      //增加半秒延迟，防止重复频繁点击
      if(this.autoOnePageState){
        return false
      }
      this.autoOnePageState = true
      this.onePageFunction(true)
      setTimeout(() => {
        this.autoOnePageState = false
      }, 1000)
    },
    //切换字体
    toggleFont(lang,item){
      this.font = item.id
      this.setFormatInfo({font:this.font})
      //更新下拉菜单打开状态
      this.updateFontState(false)
    },
    //更改format_info
    setFormatInfo (options) {
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
      //同步数据
      Object.keys(options).forEach(key => {
        cvDetail.format_info[key] = options[key]
        if(key==='line_spacing'){
          //保存行距
          this.setOldLineHeight(options[key])
        }
      })
      //同步到vuex中
      this.setCvDetail(cvDetail)

      //触发保存
      this.submit()
    },
    //修改字号
    changeFontSize () {
      this.setFormatInfo({ font_size: getNum(this.cvDetail.format_info.font_size) })
    },
    // 切换是否显示信息名称
    async selectInfo (value) {
      this.profile.show_attr_name = value
      //修改基本信息设置
      this.setProfileData({...this.profile})
      try {
        //检测是否有profile数据
        if (this.profile.id) {
          let res = await api.cvsEditor.editProfile(this.cvToken, this.profile);
          if (res.code === 1000) {
          } else {
            this.$message.success(res.message)
          }
        }

      } catch (error) {

      }
    },
    // 设置 顶部线条 显示
    setCvHeaderLineShow (type, flag, isTemplateStyle) {
      this.isShowCvHeaderLine = flag
      if (isTemplateStyle) {
        this.setFormatInfo({top_format: type})
      } else {
        this.setFormatInfo({top_format: type, template_type: null})
      }
    },
    // 保存
    async submit () {
      let { kind } = this.cvDetail.basic_info
      if (kind === 'template' || kind === 'sample') {
        // this.$message.success('保存成功')
        //修改基本信息备份基本信息设置
        this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)))
        //修改简历设置备份
        this.setBackUpFormatInfo(JSON.parse(JSON.stringify(this.cvDetail.format_info)))
        return false
      }
      try {
        let data = {
          operation_type: 'update_format_info',
          format_info: this.cvDetail.format_info
        }
        let res = {}
        if (this.isMentorEditor) {
          res = await api.cvsEditor.updatedMentorCvInfo(this.cvToken, data)
        } else {
          res = await api.cvsEditor.updatedCvInfo(this.cvToken, data);
        }
        if (res.code === 1000) {
          //修改基本信息备份基本信息设置
          this.setBackUpProfile(JSON.parse(JSON.stringify(this.profile)))
          //修改简历设置备份
          this.setBackUpFormatInfo(JSON.parse(JSON.stringify(this.cvDetail.format_info)))
          //当前右侧大tab选择类型置为空
        } else {
          this.$message.success(res.message)
        }
      } catch (error) {
        this.$message.success('修改失败')
      }
    },
    // 添加模块-检测类型及提示
    addModule(data) {
      if (data.type === 'school') {
        let { kind } = this.cvDetail.basic_info
        this.$store.dispatch('app/setAlertData', { show: true, type: 'school' });
        return false;
      }
      if (this.currentInfo.operation) {
        const alertData = {
          show: true,
          type: 'message',
          messageTitle: '添加模块提示',
          showCancelButton: true, //取消按钮
          showConfirmButton: true, // 确定按钮
          confirmButtonText: '取消',
          cancelButtonText: '确认',
          cancelButtonClass: 'cvs-edit-cancelButtonClass',
          confirmButtonClass: 'cvs-edit-confirmButtonClass',
          messageContent: `
          <p>当前模块还未完善，是否继续</p>
        `,
          confirm: close => {
            close();
          },
          cancel: async close => {
            close();
            this.addModuleNext(data);
          }
        };
        this.$store.dispatch('app/setAlertData', alertData);
        return false;
      }
      this.addModuleNext(data);
    },
    // 添加模块-整理数据
    async addModuleNext(data) {
      let { lang = 'cn', kind } = this.cvDetail.basic_info;
      let {  submodule_info } = this.cvDetail;
      const baseField = [ 'edus', 'works', 'orgs', 'extras', 'opus'];
      // 自定义模块的 id
      let customSectionId = null;
      let moduleInfo = {};
      // 从简历的section_position中把自定义模块挑出来，判断是否自定义模块是否超过5个的限制
      const customSection = submodule_info.sections_position.filter(item => item.type === 'custom');

      if (customSection.length > 5) {
        this.$message("自定模块最多添加6个");
        return;
      }

      if (data.type === 'custom') {
        // type 为自定义模块的时候，需要创建大模块，然后填充到简历的section_position中
        try {
          customSectionId = await this.createCustomSection(null, '自定义模块');
          submodule_info.sections_position.push({
            type: 'custom',
            id: customSectionId,
            info_ids: []
          });
        } catch (error) {
          console.log(error);
        }
      } else {
        if (data.type === 'extras') {
          moduleInfo = {
            skill: {
              name: '技能',
              description: null
            },
            language: {
              name: '语言',
              description: null
            },
            other: {
              name: '活动',
              description: null
            },
            interest: {
              name: '兴趣',
              description: null
            },
            certificate: {
              name: '证书/执照',
              description: null
            }
          }
          this.$store.state.editor.extras = moduleInfo;
        } else {
        }
        //查找模块id
        // 只有是自定义模块的话，才会给customSectionId赋值用于排序
        if (!baseField.includes(data.type) && data.type !== 'extras') {
          /**
           * 判断经历库中是否存在当前自定义模块的id
           * 1. 如果存在就直接set进section_position中
           * 2. 如果不存在就创建一个自定义模块
           */
          if (this.experienceList[data.type] && this.experienceList[data.type].length && !window.location.href.includes('mentor')) {
            customSectionId = this.experienceList[data.type][0].custom_section_id;
          } else {
            customSectionId = await this.createCustomSection(data.type, data[`${lang}_default_name`]);
          }
        }
        submodule_info.sections_position.push({
          type: data.type,
          id: customSectionId,
          info_ids: []
        })
      }
      if (customSectionId) {
        submodule_info.custom_sections_ids.push(customSectionId)
      }
      if (kind === null || kind === 'null') {
        await this.updateCvDetail({
          submodule_info,
          operation_type: 'update_submodule_info'
        })
        this.hiddenAllTipsFun()
        // 添加完模块之后直接进入编辑
        !this.openResumeError && this.editModule({description: ''}, submodule_info.sections_position[submodule_info.sections_position.length - 1], 'add');
      } else {
        let cv = JSON.parse(JSON.stringify(this.cvDetail))
        cv.submodule_info = submodule_info
        this.createCvDetail({payload: cv})
      }

      // 整合已添加模块列表
      let obj = {
        id: customSectionId,
        info_ids: [],
        key: data.type,
        sections_position: {
          id: customSectionId,
          info_ids: [],
          type: data.type
        },
        title: data[`${lang}_default_name`],
        type: data.type,
      }
      let list = JSON.parse(JSON.stringify(this.listMenu))
      list.push(JSON.parse(JSON.stringify(obj)))
      this.setMenuList(list)
      let moduleList = JSON.parse(JSON.stringify(this.moduleList))
      if (data.type !== 'custom') {
        moduleList = moduleList.filter(item => item.type !== data.type)
      }
      this.setFilterModule(moduleList)
      this.$nextTick(() => {
        const scrollEl = document.querySelector('.cvs-component')
        let moduleEls
        if (data.type === 'extras') {
          moduleEls = document.querySelectorAll('.extras')
        } else {
          moduleEls = document.querySelectorAll('.section-undefined')
        }
        if (moduleEls && moduleEls.length) {
          let { pageIndex, pageElHeight } = dealResumeDomScroll(moduleEls)
          this.$emit('dealCheckDomScroll', { pageIndex, pageElHeight })
          scrollEl.scrollTo({ top: moduleEls[0].offsetTop - 180, behavior: 'smooth' })
        }
      })
    },
    /**
     * @function 创建自定义模块
     * @param category: 代表创建的是哪个类型的模块, section_title: 创建的大模块名称
     * @returns 自定义模块的 id
     */
    async createCustomSection(category, section_title) {
      try {
        const res = await api.cvsEditor.createCustom({
          category,
          section_title,
          lang: this.cvDetail.basic_info.lang || 'cn',
          cv_token: this.cvToken
        });
        if (res.code === 1000) {
          // 创建大的自定义模块的时候会相应的创建一个info_id的脏数据，但是不能清除， 目前经历库维护的数据结构有经历的话才能拿到模块id
          const { custom_section: { id, infos } } = res.data;
          // copy 经历库数据，将新建的自定义模块加进去
          let experienceList = JSON.parse(JSON.stringify(this.experienceList));
          experienceList[id] = infos;

          this.updateExperienceList(experienceList);
          return id;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async selectResumeCertification(options){
      const scrollEl = document.querySelector('.cvs-component')
      const firstPage = document.querySelector('.page-index-1')
      const rect = firstPage.getBoundingClientRect()
      const clientHeight = document.body.clientHeight
      scrollEl.scrollTo({top: clientHeight > rect.height ? 0 : (rect.height - clientHeight) + 100, behavior: 'smooth'})
      //当前模块要有 key，value
      let cvDetail = JSON.parse(JSON.stringify(this.cvDetail))
      //同步数据
      Object.keys(options).forEach(key => {
        cvDetail.format_info[key] = options[key]
        if(key==='line_spacing'){
          //保存行距
          this.setOldLineHeight(options[key])
        }
      })
      //同步到vuex中
      this.setCvDetail(cvDetail);

      //触发保存
      this.submit();

    }
  }
}
</script>

<style lang="scss" scoped>
  @import './index.scss';
</style>
